import { Divider, Typography } from '@mui/material';
import { get } from 'lodash';
import React, { FC, useMemo } from 'react';
import SummaryLine from '../../../../../../components/ui-component/form-component/abschluss-page/SummaryLine';
import { useApplication } from '../../../../../../context/ApplicationContext';
import { PLATZHALTER_TEXT } from '../../../../../../lib/constants/constant';
import { DisplayDate, DisplayEuro } from '../../../../../../utils/formats';
import { enumT } from '../../../../../../utils/helper';
import AbschlussSeiteBox from '../../../antrag-components/AbschlussSeiteBox';
import ApplicationHeading from '../../../application-heading/ApplicationHeading';

// import schemas
import NachweisPositionSchema from '../../../../../../lib/paths/nachweisposition_FULL_Paths.json';
import VerwendungsNachweisSchema from '../../../../../../lib/paths/verwendungsnachweis_FULL_Paths.json';
const VN_P = VerwendungsNachweisSchema.attributes;
const NP_P = NachweisPositionSchema.attributes;

const AbschlussVN: FC<{}> = () => {
	const { application } = useApplication();

	const nachweisBetraege = useMemo(() => {
		const allKostenPosition = get(application, VN_P.Verwendungsnachweis_Nachweispositions.path, []);

		const bewilligteSumme = parseFloat(get(application, VN_P.Allgemein_Bewilligte_Foerdersumme.path, '0'));

		const summePersonalKosten = allKostenPosition.reduce((acc: any, ele: any) => {
			// if (get(ele, NP_P.Allgemein_Kostenart.path) === KOSTEN_ARTEN.Personalkosten) {
				let foerderung = parseFloat(get(ele, NP_P.Tatsaechliche_Foerderung_Tatsaechliche_Foerderung.path, '0'))-parseFloat(get(ele, NP_P.Tatsaechliche_Foerderung_Tatsaechliche_Sachkosten.path, '0'));
				if (isNaN(foerderung)) {
					foerderung = 0; // NaN abfangen
				}
				acc += foerderung;
			// }
			return acc;
		}, 0);

		const summeSachKosten = allKostenPosition.reduce((acc: any, ele: any) => {
			// if (get(ele, NP_P.Allgemein_Kostenart.path) === KOSTEN_ARTEN.Sachkosten) {
				let foerderung = parseFloat(get(ele, NP_P.Tatsaechliche_Foerderung_Tatsaechliche_Sachkosten.path, '0'));
				if (isNaN(foerderung)) {
					foerderung = 0; // NaN abfangen
				}
				acc += foerderung;
			// }
			return acc;
		}, 0);

		const differenz = bewilligteSumme - summePersonalKosten - summeSachKosten;
		const ausgereichteLandesFoerderung = (85 * bewilligteSumme) / 100;
		const restSumme = (15 * bewilligteSumme) / 100;

		const ueberschuss = differenz - restSumme;

		return {
			bewilligteSumme: bewilligteSumme,
			summePersonal: summePersonalKosten,
			summeSachkosten: summeSachKosten,
			differenz: differenz,
			ausgereichteLandesFoerderung: ausgereichteLandesFoerderung,
			restSumme: restSumme,
			ueberschuss: ueberschuss,
		};
	}, [application]);
	return (
		<>
			<ApplicationHeading title='Abschluss' description={PLATZHALTER_TEXT} />
			<Typography variant='h5' component={'p'}>
				Projektdaten
			</Typography>
			<Divider />
			<AbschlussSeiteBox>
				<SummaryLine
					label='Datum der Einreichung:'
					value={
						get(application, VN_P.Allgemein_Eingereicht_Am.path) ?
							DisplayDate(get(application, VN_P.Allgemein_Eingereicht_Am.path))
						:	'Noch nicht eingereicht'
					}
				/>
				<SummaryLine
					label='MKS:'
					value={get(application, VN_P.Antrag.schema.attributes.MKS.schema.attributes.Geschaeftsbezogene_Daten_Name_Der_Organisation.path)}
				/>
				<SummaryLine label='Antragstitel:' value={get(application, VN_P.Antrag.schema.attributes.Zusammenfassung_Ueberblick_Titel.path, '')} />
				<SummaryLine label='Status:' value={enumT(get(application, VN_P.Status_Status.path))} />
				<SummaryLine
					label='Laufzeit von:'
					value={DisplayDate(get(application, VN_P.Antrag.schema.attributes.Zusammenfassung_Ueberblick_Laufzeit_Von.path))}
				/>
				<SummaryLine
					label='Laufzeit bis:'
					value={DisplayDate(get(application, VN_P.Antrag.schema.attributes.Zusammenfassung_Ueberblick_Laufzeit_Bis.path))}
				/>
				<SummaryLine label='Bewilligte Fördersumme:' value={DisplayEuro(get(nachweisBetraege, 'bewilligteSumme', 0))} />
				{/* <SummaryLine label='Tatsächliche Summe:' value={DisplayEuro(get(application, VN_P.Allgemein_Tatsaechliche_Summe.path, 0))} /> */}
			</AbschlussSeiteBox>
			{/* Summe aller Kosten*/}
			<AbschlussSeiteBox>
				<Typography variant='h5' component={'p'}>
					Tatsächliche Kosten
				</Typography>
				<Divider />
				<SummaryLine label='Personalkosten:' value={DisplayEuro(get(nachweisBetraege, 'summePersonal', 0))} />
				<SummaryLine label='Sachkosten:' value={DisplayEuro(get(nachweisBetraege, 'summeSachkosten', 0))} />
				<SummaryLine label='Summe:' value={DisplayEuro(get(nachweisBetraege, 'summeSachkosten', 0)+get(nachweisBetraege, 'summePersonal', 0))} />
				<SummaryLine label='Differenz zu bewilligten Fördersumme:' value={DisplayEuro(get(nachweisBetraege, 'differenz', 0))} />
			</AbschlussSeiteBox>
			{/* Landesförderung*/}
			<AbschlussSeiteBox>
				<Typography variant='h5' component={'p'}>
					Landesförderung
				</Typography>
				<Divider />
				<SummaryLine label='Bewilligte Landesförderung:' value={DisplayEuro(get(nachweisBetraege, 'bewilligteSumme', 0))} />
				<SummaryLine label='ausgereichte Landesförderung (85%):' value={DisplayEuro(get(nachweisBetraege, 'ausgereichteLandesFoerderung', 0))} />
				<SummaryLine label='Restsumme (15% Einbehalt):' value={DisplayEuro(get(nachweisBetraege, 'restSumme', 0))} />
			</AbschlussSeiteBox>
			{/* ERmittlung des Überschusses/Fehlbetrag*/}
			<AbschlussSeiteBox>
				<Typography variant='h5' component={'p'}>
					Ermittlung des Überschusses/Fehlbetrags
				</Typography>
				<Divider />
				<SummaryLine label='Differenz aus 1. (tatsächliche Personalkosten):' value={DisplayEuro(get(nachweisBetraege, 'differenz', 0))} />
				<SummaryLine label='Restsumme aus 2. (15% Einbehalt):' value={DisplayEuro(get(nachweisBetraege, 'restSumme', 0))} />
				<SummaryLine label='Überschuss/ Fehlbetrag:' value={DisplayEuro(get(nachweisBetraege, 'ueberschuss', 0))} />
			</AbschlussSeiteBox>
		</>
	);
};

export default AbschlussVN;
